"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(product, text) {
  var _product$info;
  var technicalData = product === null || product === void 0 ? void 0 : (_product$info = product.info) === null || _product$info === void 0 ? void 0 : _product$info.technicalData;
  var availability = technicalData.find(function (data) {
    return (data === null || data === void 0 ? void 0 : data.label) === "available_from";
  });
  if (availability) {
    var datePart = availability.name.split(" ")[0].split("-");
    return text + ": " + datePart[1] + "." + datePart[0];
  }
  return null;
};
exports["default"] = _default;